import React, { useState } from "react";
import { Button } from "react-bootstrap";
import TablePaginationBar from "../TablePaginationBar";

const PayerMatrixPagination = ({
  totalItems,
  rowsPerPage,
  setRowsPerPage,
  currentPage,
  setCurrentPage,
}) => {
  const [showAll, setShowAll] = useState(false);
  const [originalRowsPerPage] = useState(rowsPerPage);

  if (totalItems === 0) return null;

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handleViewAll = () => {
    setRowsPerPage(totalItems);
    setShowAll(true);
    setCurrentPage(1);
  };

  const handleViewLess = () => {
    setRowsPerPage(originalRowsPerPage);
    setShowAll(false);
    setCurrentPage(1);
  };

  if (showAll) {
    return (
      <div className="d-flex justify-content-end align-items-center px-4 py-3">
        <Button
          onClick={handleViewLess}
          size="sm"
          style={{
            backgroundColor: "#27B99A",
            border: "none",
            borderRadius: "6px",
            fontWeight: "500",
            padding: "6px 16px",
          }}
          variant="success"
        >
          View Less
        </Button>
      </div>
    );
  }

  return (
    <TablePaginationBar
      currentPage={currentPage}
      totalItems={totalItems}
      rowsPerPage={rowsPerPage}
      onPageChange={paginate}
      leftExtra={
        <Button
          onClick={handleViewAll}
          size="sm"
          style={{
            backgroundColor: "#27B99A",
            border: "none",
            borderRadius: "6px",
            fontWeight: "500",
            padding: "6px 16px",
          }}
          variant="success"
        >
          View All
        </Button>
      }
    />
  );
};

export default PayerMatrixPagination;
